import { GitTreeItem } from '../models/git-worker.model';
import { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';
import { FSReadDirActionFn } from './fs-read-dir';
import { FSRmDirActionFn } from './fs-rm-dir';

export interface FSRemoveEmptyDirsAction extends WorkerAction {
  type: FSAction.RemoveEmptyDirs;
}

export async function FSRemoveEmptyDirsFn(params: WorkerFnParams<FSRemoveEmptyDirsAction>): Promise<void> {
  const { util } = params;

  // look for empty folders and remove manually
  const { tree: srcFolder } = await FSReadDirActionFn({
    ...params,
    params: { path: './' },
  });

  const rootFolders = Object.values(srcFolder['src']?.children || {})
    .filter((child) => child.type === 'dir')
    .map((child) => child.name);

  const isEmptyFolder = (item: GitTreeItem) => util.isDir(item.path) && Object.keys(item.children || {}).length === 0;
  const foldersToRemove = Object.values(rootFolders)
    .map((folder) => {
      const children = srcFolder[folder]?.children || {};

      const subFolders = Object.keys(children)
        .filter((item) => util.isDir(children[item]?.path ?? ''))
        .map((subFolder) => children[subFolder]);

      if (!subFolders.length) {
        return [];
      }

      return subFolders
        .filter((item): item is GitTreeItem => !!item)
        .filter(
          (subFolder) =>
            // there are no children(empty folder)
            isEmptyFolder(subFolder) ||
            // all children are directories with empty children(e.g. empty 'runs' folder)
            Object.values(subFolder.children || {}).every((child) => isEmptyFolder(child)),
        );
    })
    .flat()
    .filter(Boolean)
    .map(({ path }) => path)
    .filter((path) => util.isDir(path));

  await Promise.all(
    foldersToRemove.map(async (path) => {
      console.debug(`[WasmGit]: removing folder "${path}"`);
      return FSRmDirActionFn({
        ...params,
        params: { path },
      });
    }),
  );
}
